export default "__VITE_ASSET__c8e8d1c9__"